import { render, staticRenderFns } from "./mDeleteModal.vue?vue&type=template&id=fd4f4702"
import script from "./mDeleteModal.vue?vue&type=script&lang=ts"
export * from "./mDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports